const formatCents = (amount: string | undefined) => {
  if (!amount) return '0'

  // Se já tem ponto decimal, assumir que está no formato correto
  if (String(amount).includes('.')) {
    return String(amount).split('.')[1].length === 1 ? amount + '0' : amount
  }

  // Se não tem ponto decimal, assumir que está em centavos e converter para reais
  const amountStr = String(amount)
  if (amountStr.length <= 2) {
    return '0.' + amountStr.padStart(2, '0')
  }

  return amountStr.slice(0, -2) + '.' + amountStr.slice(-2)
}

export const formatCentsToSendToBackEnd = (amount: string | undefined) => {
  if (!amount) return '0'
  return (
    amount.substring(0, amount.length - 2) +
    '.' +
    amount.substring(amount.length - 2, amount.length)
  )
}

export default formatCents
